import { render, staticRenderFns } from "./side-bar-item.vue?vue&type=template&id=1b93cdc0&scoped=true"
import script from "./side-bar-item.vue?vue&type=script&lang=js"
export * from "./side-bar-item.vue?vue&type=script&lang=js"
import style0 from "./side-bar-item.vue?vue&type=style&index=0&id=1b93cdc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b93cdc0",
  null
  
)

export default component.exports